import type { StaticLayerPayload } from "@config";
import { ArrayLibrary, ArrayPdf } from "@library-combos/array";
import { Container } from "../Container";

export const Array = ({ entity }: StaticLayerPayload) => (
  <Container
    entity={entity}
    views={{
      default: ArrayLibrary,
      pdf: ArrayPdf,
    }}
  />
);
